class MapBackdropApp
    init: (options = {}) ->
        @options = @mergeOptions(options)

        # if mapbox wasn't loaded, the rest of this is useless
        if not L.mapbox?
            console.error 'Failed to load map'
            return

        L.mapbox.accessToken = 'pk.eyJ1IjoibXlmYXJtcyIsImEiOiJaY2gzXzJvIn0.Kh5pHZFlBBoMXbWMtl246A'
        @map = L.mapbox.map 'map-wrapper', 'myfarms.mcda6mi2',
            attributionControl: false
            zoomControl: false
            maxBounds: [[-90, -180], [90, 180]]
            continuousWorld: false
            dragging: false
            touchZoom: false
            scrollWheelZoom: false
            doubleClickZoom: false
            boxZoom: false
            maxZoom: 19
            minZoom: 2
        .setView([44.563, -98.235], 14)

        if @options.useModal
            @setModalLocation()

        if @options.panMap
            setTimeout () =>
                @panMap()
                setInterval @panMap, 7500
            , 2000

    panMap: () =>
        x = Math.max(200, Math.random() * 350)
        y = Math.max(200, Math.random() * 350)

        x = if Math.random() > 0.5 then x else x * -1
        y = if Math.random() > 0.5 then y else y * -1
        @map.panBy [x, y], { animate: true, duration: 6 }

    setModalLocation: () =>
        m_w = $('.modal').outerWidth()
        b_w = $('body').width()

        $('.modal').css
            'left': (b_w / 2) - (m_w / 2),
            'marginLeft': '0px',
            'top': '160px'

    mergeOptions: (options) =>
        return $.extend({
            useModal: true,
            panMap: false
        }, options)

module.exports = MapBackdropApp
